/*
 * @Author: Suroc
 * @Date: 2024-01-25 18:10:01
 * @LastEditTime: 2024-12-25 16:07:27
 * @Description: Router
 */
import { createRouter, createWebHistory } from 'vue-router'
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    // {
    //   path: '/admin',
    //   name: 'Admin',
    //   meta: {
    //     title: '后台管理'
    //   },
    //   component: () => import('@/pages/admin/index.vue')
    // },
    {
      path: '/home',
      name: 'Home',
      meta: {
        title: 'Home'
      },
      component: () => import('@/pages/home/index.vue')
    },
    {
      path: '/miningmachine',
      name: 'MiningMachine',
      meta: {
        title: 'Land'
      },
      component: () => import('@/pages/miningmachine/index.vue')
    },
    {
      path: '/profit',
      name: 'Profit',
      meta: {
        title: 'Profit'
      },
      component: () => import('@/pages/profit/index.vue')
    },
    {
      path: '/history',
      name: 'History',
      meta: {
        title: 'History'
      },
      component: () => import('@/pages/profit/history.vue')
    },
    {
      path: '/landhistory',
      name: 'Land History',
      meta: {
        title: 'Land History'
      },
      component: () => import('@/pages/miningmachine/history.vue')
    },
    {
      path: '/team',
      name: 'Team',
      meta: {
        title: 'Team'
      },
      component: () => import('@/pages/team/index.vue')
    },
    {
      path: '/develop',
      name: 'Develop',
      meta: {
        title: 'Develop'
      },
      component: () => import('@/pages/develop/index.vue')
    },
    {
      path: '/signin',
      name: 'Signin',
      meta: {
        title: 'Signin'
      },
      component: () => import('@/pages/develop/signin.vue')
    },
    {
      path: '/permission',
      name: 'Permission',
      meta: {
        title: 'Permission'
      },
      component: () => import('@/pages/develop/permission.vue')
    },
    {
      path: '/flst',
      name: 'NFT',
      meta: {
        title: 'NFT'
      },
      component: () => import('@/pages/flst/flst.vue')
    },
    {
      path: '/order',
      name: 'Order',
      meta: {
        title: 'Order'
      },
      component: () => import('@/pages/orderlogs/order.vue')
    },
    {
      path: '/logs',
      name: 'Logs',
      meta: {
        title: 'Logs'
      },
      component: () => import('@/pages/orderlogs/logs.vue')
    },
    {
      path: '/walletFlst',
      name: 'WalletFlst',
      meta: {
        title: 'Wallet'
      },
      component: () => import('@/pages/wallet/flst.vue')
    },
    {
      path: '/walletLogs',
      name: 'walletLogs',
      meta: {
        title: 'walletLogs'
      },
      component: () => import('@/pages/wallet/logs.vue')
    },
    {
      path: '/teams',
      name: 'teams',
      meta: {
        title: 'teams'
      },
      component: () => import('@/pages/orderlogs/teams.vue')
    },
    {
      path: '/tree',
      name: 'tree',
      meta: {
        title: 'Tree'
      },
      component: () => import('@/pages/tree/tree.vue')
    },
    {
      path: '/protected-example',
      name: 'ProtectedExample',
      meta: {
        title: 'Protected Content'
      },
      component: () => import('@/views/ProtectedExample.vue')
    },
  ]
})

// 在全局导航守卫中更改标签标题
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | CCR` || 'CCR'
  next()
})

export default router
